import { init } from '@elastic/apm-rum';

import { PayloadErrorAPM } from '../types';
import Config from './config';

const apm = init({
  serviceName: Config.REACT_APP_ELASTIC_APM_SERVICE_NAME ?? 'ats',
  serverUrl: Config.REACT_APP_ELASTIC_APM_SERVER_URL,
  serviceVersion: Config.REACT_APP_IMAGE_VERSION ?? '',
  environment: Config.REACT_APP_ELASTIC_APM_ENVIRONMENT ?? 'production',
  pageLoadTraceId: Config.REACT_APP_ELASTIC_APM_PAGE_LOAD_TRACE_ID,
  pageLoadSpanId: Config.REACT_APP_ELASTIC_APM_PAGE_LOAD_SPAN_ID,
  pageLoadSampled: Config.REACT_APP_ELASTIC_APM_PAGE_LOAD_SAMPLED,
});

apm.setUserContext({
  id: Config.REACT_APP_ELASTIC_APM_USER_ID,
  username: Config.REACT_APP_ELASTIC_APM_USERNAME,
  email: Config.REACT_APP_ELASTIC_APM_USER_EMAIL,
});

apm.addLabels({ tenant: Config.REACT_APP_ELASTIC_APM_TENANT ?? 'public' });

//Removes ResizeObserver error that can be ignored -> https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
apm.addFilter((payload) => {
  payload.errors = payload.errors.filter((error: PayloadErrorAPM) => {
    if (error.exception.message.includes('ResizeObserver loop')) {
      return false;
    }
    return true;
  });
  return payload;
});
